import { nextTick,defineComponent, ref, provide, reactive, toRefs, getCurrentInstance, onMounted, onBeforeUnmount, onBeforeUpdate } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import HeaderVR from '@/components/layout/header_vr.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import Swiper from '@/components/layout/Swiper.vue';
import bus from 'vue3-eventbus'
import SideComponent from '@/components/common/SideComponent.vue';
import Loading from '@/components/common/Loading.vue';
import { wexinShare } from '@/utils/wxshare.js';
// import LivePlayer from '@liveqing/liveplayer-v3';
// import LivePlayerDemo from '@/components/LivePlayerDemo.vue'
// import VideoPlayer from '@/components/VideoPlayerCom.vue';
// import HlsPlayer2 from '@/components/HlsPlayer2.vue';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// 如果需要播放HLS，在现代浏览器中通常已支持，但为了兼容性可能仍需引入hls.js
import Hls from 'hls.js';

export default defineComponent({
    components: {
        HeaderVR,
        Menu,
        Footer,
        PageLoading,
        Swiper,
        SideComponent,
        // LivePlayer,
        // LivePlayerDemo,
        // VideoPlayer,
        // HlsPlayer2,

    },
    props: {

    },
    setup() {
        provide('logoColor', 'black');
        let {ctx, proxy} = getCurrentInstance();
        console.log(proxy,"proxy");
        const router = useRouter();
        const route = useRoute();
        const id = route.query.id;
        const type = route.query.type;
        const data = reactive({
            isLoading:true,
            showHeader: true,
            loginStyle: "min-width:141px;",
            mobileIconStyle: "color:rgba(223, 58, 8, 1);",
            showListIcon: true,			
            showHeader:false,
            player: null,
            ws: null,
            statusMessage: '未连接',
            errorMessage: '',
            isTranscoding: false,
            m3u8Url: ''
        });
        
        const showMenus = ref(proxy.$menus);
        provide('showMenu', showMenus);
        provide('menuTextStyle', {color:'#fff'});
        provide('showHeader',false);
        
        data.id = id;
        console.log(data.id,'id');
        // data.type = type;

        const getImageUrl = (name) => {
            return proxy.$utils.getImageUrl(name);
        };

        const store = useStore();
        const getTaleDetail = (id=0) => {
            
        }
        const wxshare = (share_data) => {
            const protocol = window.location.protocol; // 协议 (e.g., "https:")
            const hostname = window.location.hostname; // 域名 (e.g., "example.com")
            let url = protocol+'//'+hostname;
            if(hostname.indexOf("www") == -1){
                url = protocol+'//www.'+hostname;
            }
            url = url+route.fullPath;
            store.dispatch("common/Jssdk",{
                url:url
            }).then((res) => {
                // console.log(res,'jssdk');
                //微信加签              
                // var shareWxLink = encodeURIComponent(url);加密
                let shareData = {
                    title: share_data.title, // 分享标题
                    desc:'',
                    link: url,
                    imgUrl: store.state.common.siteInfo.logo // 分享图标
                };
                //引用
                wexinShare(res, shareData);
            })
        }
        
        const viewBox = ref(null);
        const scroll = (val) => {
            if(val == 'top'){
                
                viewBox.value.scrollIntoView({
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                    block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
                    inline: "center", // 定义水平滚动方向的对齐
                });
               
            }else if(val == 'bottom'){
                
                viewBox.value.scrollIntoView({
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                    block: "end", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
                    inline: "center", // 定义水平滚动方向的对齐
                });
    
            }
        }
        
        // Make sure to reset the refs before each update.
        onBeforeUpdate(() => {
            
        });
        onBeforeUnmount(()=>{
            
        })
        
        onMounted(async()=>{
            let timer = setTimeout(() => {
                data.isLoading = false;
                viewBox.value.scrollIntoView({
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                    block: "start", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
                    inline: "center", // 定义水平滚动方向的对齐
                });
              clearTimeout(timer);
            }, 500);
            console.log("页面数据更新完毕了")
        })

        const refData = toRefs(data);

        return {
            ...refData,
            getImageUrl,
            viewBox,
            scroll,
            getTaleDetail,
            wxshare,
            
        }
    },
    created() {

    },
    mounted() {
        this.$nextTick(() => {
            // this.init();
            this.initWebSocket();
            this.initializePlayer();
        });
    },
    beforeUnmount() {
        if (this.ws) {
            this.ws.close();
        }
        if (this.player) {
            this.player.dispose();
        }
    },
    methods: {
        initWebSocket() {
            // 建立 WebSocket 连接，根据后端配置调整 URL
            this.ws = new WebSocket('ws://localhost:3000');
            this.ws.onopen = () => {
                this.statusMessage = '已连接到服务器';
                console.log('WebSocket connected');
            };
            this.ws.onmessage = (event) => {
                const data = JSON.parse(event.data);
                switch (data.type) {
                case 'status':
                    this.statusMessage = data.message;
                    break;
                case 'progress':
                    console.log('Progress:', data.data);
                    // 可以更新进度条等信息
                    break;
                case 'error':
                    this.errorMessage = data.message;
                    this.isTranscoding = false;
                    break;
                default:
                    console.log('Received:', data);
                }
            };
            this.ws.onerror = (error) => {
                console.error('WebSocket error:', error);
                this.errorMessage = 'WebSocket 连接错误';
            };
            this.ws.onclose = () => {
                this.statusMessage = 'WebSocket 连接已关闭';
            };
            },
            initializePlayer() {
            // 初始化 video.js 播放器
            this.player = videojs(this.$refs.videoPlayer, {
                sources: [{
                    src: this.m3u8Url || '', // 初始可以为空，转码成功后更新
                    type: 'application/x-mpegURL'
                }],
                fluid: true
            });
        },
        async startTranscode() {
            this.isTranscoding = true;
            this.errorMessage = '';
            this.statusMessage = '开始转码...';
            try {
                const response = await fetch('http://localhost:3000/start-transcode', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        rtmpUrl: 'rtmp://liteavapp.qcloud.com/live/liteavdemoplayerstreamid' // 替换为你的 RTMP 源
                    })
                });
                const result = await response.json();
                console.log(result,'result');
                if (result.success) {
                    this.m3u8Url = result.m3u8Url;
                    this.statusMessage = '转码成功！';
                    if (this.player) {
                        this.player.src({ src: this.m3u8Url, type: 'application/x-mpegURL' });
                        this.player.play();
                    }
                } else {
                    this.errorMessage = result.error;
                }
            } catch (error) {
                this.errorMessage = error.message;
            } finally {
                this.isTranscoding = false;
            }
        }
        
    },
    beforeDestroy() {
        if (this.ws) {
            this.ws.close();
        }
        if (this.player) {
            this.player.dispose();
        }
    },
})